import { Injectable } from '@angular/core';
import {Store} from '@ngrx/store';
import {WatchlistApplicationState} from '../../store/watchlist-state';
import {WatchListActions} from '../../store/actions/WatchListActions';
import {VehicleFilter} from '../domain';
import { Observable } from "rxjs/Observable";
import {Subject} from 'rxjs/Subject';
import {LocalStorageService} from '@nw/ui-core-shared/services';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
@Injectable()
export class VehicleFilterService {

  filters: string[] = [];
  filterQuery = '';
  filterListObject: VehicleFilter[] = [];
  ifClearAllCategories = new BehaviorSubject(false);
  ifMobileSidebarToOpen = new BehaviorSubject(false);
  // filteredItems = new Subject();

  constructor(
    private store: Store<WatchlistApplicationState>,
    private watchListActions: WatchListActions,
    private localStorage: LocalStorageService
  ) { this.localStorage.setLocalObject('NW.wl-filter', '')   }

  getFilterQuery(): string {
    return this.filterQuery;
  }

  getFilterOptionData(data) {
    let aggregations = data;
    if (aggregations && aggregations.length > 0) {
      aggregations = aggregations.reduce((results, option) => {
        option.buckets = option.buckets.filter(bucket => bucket.value);
        if (option.buckets.length > 0) {
          results.push(option);
        }
        return results;
      }, []);
    }
    return aggregations;
  }

  doFiltering(filterObj) {
    this.filterQuery = this.queryConverter(filterObj);
    this.store.dispatch(this.watchListActions.loadWatchList());
    this.localStorage.setLocalObject('NW.wl-filter', this.filterQuery);
  }

  queryConverter(filterObj) {
    let result = '';

    filterObj.map((item) => {
      if (item.buckets.length > 0 ) {
        result += `&filter_${item.category}=`;
        let filterValueList = [];
        item.buckets.map((bucket) => {
          filterValueList.push(bucket.value);
        });
        result += encodeURIComponent(JSON.stringify(filterValueList));
      }
    });

    return result;
  }

    passEventToSidebarClearAllCategories() {
      this.ifClearAllCategories.next(true);
    }

    passEventToMobileSidebarToOpen() {
      this.ifMobileSidebarToOpen.next(true);
    }
}



// WEBPACK FOOTER //
// ./node_modules/@nw/ui-watchlist/shared/services/vehicle-filter.service.ts